import { useContext } from 'react';
import { AddToBasketContext } from './AddToBasketProvider';

export const useAddToBasketContext = () => {
    return useContext(AddToBasketContext);
};
